export const RESULT_FIELDS = [
  'age',
  'ageGroup',
  'ageGroupGenderPlace',
  'ageGroupPlace',
  'bib',
  'chipTime',
  'division',
  'divisionPlace',
  'finishTimeLocal',
  'fromCity',
  'fromCountry',
  'gender',
  'genderPlace',
  'gunStartTime',
  'gunTime',
  'name',
  'netTime',
  'overallPace',
  'overallPlace',
  'pace',
  'raceTime',
  'percentComplete',
  'countSegmentResults',
  'distance',
  'distanceUnit',
];

export const SEGMENT_FIELDS = [
  'ageGroupGenderPlace',
  'ageGroupGenderPlaceLabel',
  'ageGroupPlace',
  'ageGroupPlaceLabel',
  'cumulativePace',
  'distance',
  'distanceUnit',
  'distanceValues',
  'divisionPlace',
  'endTimeLocal',
  'genderPlace',
  'overallPlace',
  'pace',
  'participantName',
  'raceTime',
  'raceTimeSec',
  'screenshot',
  'segmentCumulativePace',
  'segmentCumulativePaceSortValue',
  'segmentCumulativePaceUnits',
  'segmentId',
  'segmentPace',
  'segmentPaceSortValue',
  'segmentPaceUnits',
  'splitTime',
  'splitTimeSec',
  'tally',
];

// Number of times to retry preloading certificate assets (logo, wavy-line
// backgrounds) before leaving the certificate download unavailable.
export const MAX_PRELOAD_ATTEMPTS = 3;

export const TEMPLATE_CERTIFICATE_WIDTH = 3300;
export const TEMPLATE_CERTIFICATE_HEIGHT = 2550;
export const LEGACY_CERTIFICATE_WIDTH = 950;
export const LEGACY_CERTIFICATE_HEIGHT = 735;

// Locked templates are certificates ported from the legacy editor, so their HTML is authored
// against the legacy canvas and has to be scaled up to fill the template canvas.
export const LOCKED_CERTIFICATE_ZOOM = TEMPLATE_CERTIFICATE_WIDTH / LEGACY_CERTIFICATE_WIDTH;

// Keep in sync with the timer-dashboard CertificatePreview constant.
export const CERTIFICATE_PREVIEW_READY = 'certificate-preview-ready';
